export default "__VITE_ASSET__bQu8477P3zafLmoWdejfRQ__"